import doc from "../../src/svg_icons/doc.png";
import txtIcon from "../../src/svg_icons/txtIcon.png";
import excelIcon from "../../src/svg_icons/excelIcon.png";
import pptIcon from "../../src/svg_icons/pptIcon.png";
import pdfIcon from "../../src/svg_icons/pdfIcon.png";


export const API_END_POINT = process.env.REACT_APP_BACK_END_API;
export const config = {
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
};

export const MESSAGE_LENGTH = 25;
export const MESSAGES_REFRESH_INTERVAL = 30000;

export const LIMIT = 10;
export const PAGE = 1;
export const TEXTLIMIT = 50;
export const PHONELIMITE = 10;
export const LARGELIMIT = 100;
export const HOURSLIMITE = 2;
export const MARKSLIMITE = 3;

export const sales_color = "#cc0505";
export const support_color = "#008000";
export const account_color = "#fdbe36";
export const technical_color = "#342fc8";
export const other_color = "#e621c5";

export const SALES = <span style={{ color: "#cc0505" }}>Sales</span>;
export const SUPPORT = <span style={{ color: "#008000" }}>Support</span>;
export const ACCOUNT = <span style={{ color: "#fdbe36" }}>Account</span>;
export const TECHNICAL = <span style={{ color: "#342fc8" }}>Technical</span>;
export const OTHER = <span style={{ color: "#e621c5" }}>Other</span>;

/*
  GET ALL ADMIN
*/
export const ALL_ADMIN_LIST = API_END_POINT + "/user";


/*
  Admin APIs = { LOGIN, SEND OTP, RESEND OTP, VERIFY OTP}
*/
export const ADMIN_LOGIN_API = API_END_POINT + "/auth/user/admin/signin";
export const ADD_NEW_USER_API = API_END_POINT + "/auth/user/signup"
export const ADMIN_SEND_LOGIN_OTP_API =
  API_END_POINT + "/auth/user/signin/otp/email/send";
export const ADMIN_SEND_FORGOT_PASSWORD_OTP_API =
  API_END_POINT + "/auth/reset/otp/email";
export const ADMIN_VERIFY_FORGOT_PASSWORD_OTP_API =
  API_END_POINT + "/auth/reset/verify/email";
export const ADMIN_UPDATE_FORGOT_PASSWORD =
  API_END_POINT + "/auth/reset/password";
export const ADMIN_RESEND_LOGIN_OTP_API =
  API_END_POINT + "/auth/user/signin/otp/email/resend";
export const ADMIN_VERIFY_LOGIN_OTP_API =
  API_END_POINT + "/auth/user/signin/otp/email/verify";

export const ADMIN_DETAILS_API = API_END_POINT + "/user/me";

export const ADMIN_SEND_LOGIN_OTP_API_PHONE =
  API_END_POINT + "/auth/user/signin/otp/phone/send";
export const ADMIN_RESEND_LOGIN_OTP_API_PHONE =
  API_END_POINT + "/auth/user/signin/otp/phone/resend";
export const ADMIN_VERIFY_LOGIN_OTP_API_PHONE =
  API_END_POINT + "/auth/user/signin/otp/phone/verify";

export const SCHOOL_LIST_API = API_END_POINT + "/school";
export const ADD_SCHOOL_API = API_END_POINT + "/school";
export const UPDATE_SCHOOL_API = API_END_POINT + "/school";
export const SINGLE_SCHOOL_DATA = API_END_POINT + "/school";
export const SINGLE_SCHOOL_COMMUNICATION_DATA =
  API_END_POINT + "/message/school";
export const SCHOOL_STUDENT_COUNT_API = API_END_POINT + "/school/data"

export const SCHOOLPAYMENT_LIST_API = API_END_POINT + "/payment";
export const ADD_SCHOOLPAYMENTREFUND_API = API_END_POINT + "/payment/refund/school";
export const SINGLE_SCHOOLPAYMENT_API = API_END_POINT + "/payment";

export const PLAN_LIST_API = API_END_POINT + "/plan";
export const SINGLE_PLAN_API = API_END_POINT + "/plan";
export const UPDATE_PLAN_API = API_END_POINT + "/plan";

export const PROGRAMS_LIST_API = API_END_POINT + "/program";
export const ADD_PROGRAM_API = API_END_POINT + "/program";
export const UPDATE_PROGRAM_API = API_END_POINT + "/program";

export const MODUAL_LIST_API = API_END_POINT + "/module";
export const ADD_MODUAL_API = API_END_POINT + "/module";
export const UPDATE_MODUAL_API = API_END_POINT + "/module";

export const COUNTRY_LIST = API_END_POINT + "/country";

export const ADD_COURSE_API = API_END_POINT + "/course";
export const COURSE_LIST_API = API_END_POINT + "/course";
export const UPDATE_COURSE_API = API_END_POINT + "/course";

export const ADD_TOPIC_API = API_END_POINT + "/topic";
export const TOPIC_LIST_API = API_END_POINT + "/topic";
export const UPDATE_TOPIC_API = API_END_POINT + "/topic";

export const COMMUNICATION_LIST_API = API_END_POINT + "/message";
export const SEND_MESSAGE = API_END_POINT + "/message/send";
export const SAVE_MESSAGE = API_END_POINT + "/message/save";
export const IMPORTANT_MESSAGE = API_END_POINT + "/message/important";
export const DELETE_MESSAGE = API_END_POINT + "/message/delete";
export const DELETE_MESSAGE_PERMENANT = API_END_POINT + "/message";
export const REPLY_MESSAGE = API_END_POINT + "/message/reply";
export const READ_MESSAGE = API_END_POINT + "/message/read";

export const LICENSE_LIST_API = API_END_POINT + "/license";
export const ADD_LICENSE_API = API_END_POINT + "/license";
export const DELETE_LICENSE_API = API_END_POINT + "/license";
export const SINGLE_LICENSE_API = API_END_POINT + "/license";
export const UPDATE_LICENSE_API = API_END_POINT + "/license";

export const INVOICE_LIST_API = API_END_POINT + "/invoice";
export const ADD_INVOICE_API = API_END_POINT + "/invoice";
export const SAVE_INVOICE = API_END_POINT + "/invoice/save";
export const DRAFT_INVOICE = API_END_POINT + "/invoice/draft";
export const SEND_INVOICE = API_END_POINT + "/invoice/send";
export const SEND_CUSTOM_INVOICE = API_END_POINT + "/invoice/create";
export const INVOICE_DELETE_API = API_END_POINT + "/invoice";
export const SINGLE_INVOICE_API = API_END_POINT + "/invoice";

export const PROVINCE_TAX = API_END_POINT + "/provinceTax"

export const DASHBOARD_API = API_END_POINT + "/dashboard";
export const NOTIFICATION_LIST = API_END_POINT + "/notifications";
export const NOTIFICATION_UPDATE = API_END_POINT + "/notifications";
export const NOTIFICATION_CLEAR_ALL = API_END_POINT + "/notifications/clear-all";

export const SIGNED_URL = API_END_POINT + "/file/signed-url";

export const GET_PROVINCE_TAX = API_END_POINT + "/provinceTax";

export const GET_PLAN_HISTORY = API_END_POINT + "/plan/history/school";

export const LOGOUT_API = API_END_POINT + "/auth/logout"

export const DRAFT = 0;
export const SENT = 2;
export const FAILED = 3;
export const IMPORTANT = 4;
export const DELETED = 5;
export const SAVED = 6;
export const STATUS = 7;

export const STANDARD = 1;
export const PLATINUM = 2;

export const RELOAD_NOTIFICATION = 5000;

export const provinceName = (value: string) => {
  switch (value) {
    case "1":
      return "Alberta";
    case "2":
      return "Ontario";
    case "3":
      return "British Columbia";
    case "4":
      return "Quebec";
    case "5":
      return "Nova Scotia";
    case "6":
      return "New Brunswick";
    case "7":
      return "Manitoba";
    case "8":
      return "Prince Edward Island";
    case "9":
      return "Saskatchewan";
    case "10":
      return "Newfoundland and Labrador";
    case "11":
      return "Northwest Territories";
    case "12":
      return "Nunavut";
    case "13":
      return "Yukon";
  }
};

export const manageIconType = (value: string) => {
  switch (value) {
    case "application/pdf":
      return pdfIcon;
    case "application/msword":
      return doc;
    case "text/plain":
      return txtIcon;
    case "application/vnd.ms-excel":
      return excelIcon;
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return excelIcon;
    case "application/vnd.ms-powerpoint":
      return pptIcon;
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return pptIcon;
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return doc;
  }
};